export * from "Search/Scenarios/Shared/Components/ResultsInfo/index";
